import { Actions } from '@components/shared/Actions'
import { EditIcon } from '@assets/svgs/EditIcon'
import { DeleteIcon } from '@assets/svgs/DeleteIcon'
import { Tooltip } from '@components/shared/Tooltip'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { OtherServicesItemProps } from '@pages/InvoicingClientModal/context/types'
import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'

interface ParseOtherServicesProps {
  actionsDisabled?: boolean
  data: OtherServicesItemProps[]
  onEdit: (data: OtherServicesItemProps) => void
  onDelete: (data: OtherServicesItemProps) => void
}

export const parseOtherServicesGrid = ({ data, actionsDisabled, onEdit, onDelete }: ParseOtherServicesProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'clientName',
      columnName: 'Cliente',
      value: item.clientName ? (item.clientId ? `${item.clientId} - ${item.clientName}` : item.clientName) : '',
      minWidth: '14rem',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'clientType',
      columnName: 'Tipo Cliente',
      value: item.clientType || '',
      minWidth: '10rem',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'description',
      columnName: 'Descrição',
      value: item.description || '',
      minWidth: '8.8rem',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'billingStartDate',
      columnName: 'Data',
      value: item.billingStartDate ? formattedDatePtBr(item.billingStartDate) : '',
      minWidth: '8rem',
      align: 'center',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'unitGrossValue',
      columnName: 'Valor Bruto Unitário',
      align: 'center',
      currency: true,
      value: item.unitGrossValue || 0,
      sortable: true,
      minWidth: '13rem',
      headerAlign: 'center',
      bodyAlign: 'right'
    },
    {
      id: 'billingTaxPercentage',
      columnName: 'Imposto (%)',
      align: 'center',
      value: item.billingTaxPercentage ? `${item.billingTaxPercentage.toFixed(2)}%`.replace('.', ',') : '',
      minWidth: '9rem',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'totalQuantity',
      columnName: 'Qtd. Total',
      align: 'center',
      value: item.totalQuantity || '',
      minWidth: '8rem',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'grossTotal',
      columnName: 'Total Bruto',
      align: 'center',
      currency: true,
      value: item.grossTotalAmount || 0,
      sortable: true,
      minWidth: '9rem',
      headerAlign: 'center',
      bodyAlign: 'right'
    },
    {
      id: 'netTotal',
      columnName: 'Total Líquido',
      align: 'center',
      currency: true,
      value: item.netTotalAmount || 0,
      sortable: true,
      headerAlign: 'center',
      bodyAlign: 'right'
    },
    {
      id: 'observations',
      columnName: 'Observações',
      value: item.observations || '',
      sortable: true,
      headerAlign: 'center'
    },
    {
      id: 'action',
      columnName: 'Ações',
      align: 'center',
      minWidth: '5rem',
      maxWidth: '5rem',
      stickyPosition: 'right',
      withoutTooltip: true,
      value: (
        <Tooltip title={actionsDisabled ? 'Não é possível editar ou excluir outros serviços!' : ''} placement="top-end">
          <Actions
            actions={[
              { label: 'Editar', icon: <EditIcon />, onClick: () => onEdit(item) },
              { label: 'Excluir', icon: <DeleteIcon />, onClick: () => onDelete(item) }
            ]}
            disabled={actionsDisabled}
          />
        </Tooltip>
      )
    }
  ])

  return parsedData
}
